import {ISolicitacaoFiltroDto} from "@models/solicitacoes/solicitacoes.ts";
import React, {useState} from "react";
import {useGeneral} from "@contexts/GeneralContext.tsx";
import {FormControl, Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {PermissionableButton} from "@shared/specialComponents/PermissionableButton.tsx";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";
import {DefaultFilterPageProps} from "@models/DefaultFilterPageProps.ts";

interface SolicitacaoFiltrosPageProps extends DefaultFilterPageProps<ISolicitacaoFiltroDto> {
}

export const SolicitacaoFiltrosPage = (props: SolicitacaoFiltrosPageProps) => {
    const {filters, setFilters} = props;
    const [filtros, setFiltros] = useState<ISolicitacaoFiltroDto>(filters ?? {});
    const {adjustSizeLevel} = useGeneral();

    const handleApply = () => {
        if (setFilters != null)
            setFilters(filtros);
    }

    const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleApply();
        }
    }

    return (
        <Grid>
            <Grid size={12} mb={1}>
                <Grid container justifyContent={'space-between'}>
                    <Grid/>
                    <Grid>
                        <PermissionableButton permission={['VisualizarSolicitacoesMembro']} label={'Aplicar Filtros'}
                                              onClick={() => {
                                                  handleApply()
                                              }}/>
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <Grid container>
                    <Grid size={{
                        sm: 12,
                        md: 6
                    }}>
                        <TextField label={'Titulo'} value={filtros.nome ?? ''} autoFocus
                                   onKeyDown={handleEnter}
                                   onChange={(e) => {
                                       setFiltros({...filtros, nome: e.target.value});
                                   }}/>
                    </Grid>
                    <Grid size={{
                        sm: 12,
                        md: 6
                    }}>
                        <FormControl variant={'filled'} fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select value={filtros.finalizado ?? 'unset'}
                                    onChange={(e) => {
                                        setFiltros({
                                            ...filtros,
                                            finalizado: e.target.value as 'true' | 'false' | undefined
                                        });
                                    }}
                                    label={'Status'}
                            >
                                <MenuItem value={"true"}>Finalizado</MenuItem>
                                <MenuItem value={"false"}>Em aberto</MenuItem>
                                <MenuItem value={'unset'}>Todos</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid size={adjustSizeLevel({micro: 12, sm: 6})}>
                        <DefaultDatePicker value={filtros.dataCriacaoInicial}
                                           label={'Data de criação inicial'}
                                           catchValue={(v) => {
                                               setFiltros({...filtros, dataCriacaoInicial: v});
                                           }}/>
                    </Grid>
                    <Grid size={adjustSizeLevel({micro: 12, sm: 6})}>
                        <DefaultDatePicker value={filtros.dataCriacaoFinal}
                                           label={'Data de criação final'}
                                           catchValue={(v) => {
                                               setFiltros({...filtros, dataCriacaoFinal: v});
                                           }}/>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};